// THIS FILE IS AUTO GENERATED
import { GenIcon } from '../lib/index.mjs';
export function MdOutlineExpandLess (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"path","attr":{"fill":"none","d":"M0 0h24v24H0V0z"},"child":[]},{"tag":"path","attr":{"d":"m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z"},"child":[]}]})(props);
};
